/**
 * BDOEX API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * Contact: mateusz.surma@mae.pl
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Defines BdoService.Models.Enumerations.CompanyType
 */
export type BdoServiceModelsEnumerationsCompanyType = 1 | 2 | 3;

export const BdoServiceModelsEnumerationsCompanyType = {
    NUMBER_1: 1 as BdoServiceModelsEnumerationsCompanyType,
    NUMBER_2: 2 as BdoServiceModelsEnumerationsCompanyType,
    NUMBER_3: 3 as BdoServiceModelsEnumerationsCompanyType
};